import React from "react";
import {NavLink} from "react-router-dom";
import ContentBox from "../../../../../../components/content-box/ContentBox";
import PageActions from "../../../../../base/PageActions";
import '../../../../../styles/Common.scss';
import '../../WorldPages.scss';
import '../../WorldDynamicContent.scss';
import Breadcrumbs from "../../../../../../components/breadcrumbs/Breadcrumbs";

interface MythologyPageProps {
}

const MythologyPage     = (props: MythologyPageProps) => {

    const page: PageActions = new PageActions({
        title: `Casarok Mythology - Chase the Fox`,
        description: "In Casarok, various myths have circulated around the world throughout the vast history of the planet!",
        keywords: ["casarok", "myth", "mythology", "mythology compendium", "origin story", "pantheon"],
        imgSrc: `chase/world/mythology/star-space.png`,
        url: `world/religion/mythology`
    });

    return page.generateMetaContent(
        <>
            <ContentBox header="Casarokan Mythology">
                <Breadcrumbs path={page.getUrl()}/>
                <div className="world-page-static">
                    <div className="world-content center">
                        <p>
                            Here you will find a listing of myths told by the Casarokans about various phenomena of the
                            universe. Of course, some of these may not be myths at all...
                        </p>
                    </div>
                    <div className="world-content">
                        <p>
                            <NavLink className="world-link block"
                                     to="/world/religion/mythology/myth-of-the-six-sisters">
                               Myth of the Six Sisters
                            </NavLink>
                            <em>The tale of the creation of Casarok by the hands of angels known as the Six Sisters</em>
                        </p>
                    </div>
                    <div className="world-content">
                        <p>
                            <NavLink className="world-link block"
                                     to="/world/religion/mythology/myth-of-the-sun-and-moon">
                                Myth of the Sun and Moon
                            </NavLink>
                            <em>An explanation for how the sun and moon rises and sets each day and night, as told by
                                the followers of the sun and moon goddesses</em>
                        </p>
                    </div>
                </div>
            </ContentBox>
        </>
    );
}

export default MythologyPage;